<template>
  <f7-list accordion-list v-if="payments" id="payments-item-received" class="itemList">
    <f7-accordion-item class="accordionForm"
      v-for="payment in payments"
      :key="payment.id">
      <f7-accordion-toggle class="accordionToggle">
        <ul>
        <li class="swipeout" style="background: #dcdcdc;">
          <div class="item-content boxRequest">
            <div class="item-media">
              <div id="greenRectangle" :style="{background: rectangleColor}"></div>
              <i class="icon list-icon" v-bind:class="getIcon(payment.status)"></i>
            </div>
            <div class="item-inner">
              <table width="100%" style="table-layout: fixed;">
                <tr>
                  <td>
                    <div style="font-weight: bold;">
                      {{ payment.reason }}
                    </div>
                    <div class="showSmallScreenOnly">
                      {{ $t('common.amnt') + ': ' + payment.amount + ' €' }}
                    </div>
                    <div class="showSmallScreenOnly statusLabel">
                      {{ $t('common.payment_date') + ' ' }} {{ payment.requestedExecutionDate | formatDate }}
                    </div>
                    <div class="showSmallScreenOnly" style="font-size: 12px;">
                      {{ $t('common.endtoendid_label') + ': ' + payment.endToEndId }}
                    </div>
                  </td>
                  <td style="width: 32%; min-width: 32%; max-width: 32%;" class="showLargeScreenOnly">
                    {{ $t('common.amnt') + ': ' + payment.amount + ' €' }}
                  </td>
                  <td style="width: 33%; min-width: 33%; max-width: 33%;" class="showLargeScreenOnly">
                    <div style='color: #8e8e93;'>
                      {{ $t('common.payment_date') + ' ' }} {{ payment.requestedExecutionDate | formatDate }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="statusLabel">
                    {{ getStatusLabel(payment.status) }}
                  </td>
                  <td>
                  </td>
                  <td style="font-size: 12px;" class="showLargeScreenOnly">
                    {{ $t('common.endtoendid_label') + ': ' + payment.endToEndId }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </li>
      </ul>
      </f7-accordion-toggle>
      <f7-accordion-content class="background-document-form left-box">
        <direct-payment-details class="container-document-form" :payment="payment"
              :showMainDetails="showPaymentMainDetails"></direct-payment-details>
      </f7-accordion-content>
    </f7-accordion-item>
  </f7-list>
</template>

<script>
import DPdetailsCapsule from './DPdetailsCapsule.vue'
import {statusLabel, statusIcon} from '@/helpers/labels'

export default {
  name: 'directPaymentsList',
  props: ['payments', 'showPaymentMainDetails'],
  components: {
    'direct-payment-details': DPdetailsCapsule
  },
  data () {
    return {
      rectangleColor: this.$engine.services.getServiceColor('6')
    }
  },
  methods: {
    getIcon (status) {
      return statusIcon('Doc_' + status)
    },
    getStatusLabel (status) {
      return statusLabel(this.$i18n, status)
    }
  }
}
</script>
